export default {
    selectedCount: state => {
        return state.selected.length;
    },
}